export default "__VITE_ASSET__CEccs6fS__"